import { render, staticRenderFns } from "./TicketActivityForm.vue?vue&type=template&id=6becfc24"
import script from "./TicketActivityForm.vue?vue&type=script&lang=js"
export * from "./TicketActivityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports